import {IczTableDataSource} from '@icz/angular-table';
import {DocumentDto, FileDto} from '|api/document';
import {DocumentSearchService, UnitViewSearchConfig} from '|shared';

export class SettledFilesInCaseFilesDataSource extends IczTableDataSource<DocumentDto | FileDto> {
  constructor(documentSearchService: DocumentSearchService, unitView: UnitViewSearchConfig) {
    super(searchParams => documentSearchService.findSettledFilesInCaseFiles(searchParams, unitView));
  }
}
